import ValidatePage from "@/router/modules/methods/validate";

export default {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/views/auth/auth.vue'),
    meta: {
        title: 'Авторизация',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await ValidatePage(next)
    }
}